import React, { Component } from 'react';
import { connect } from 'react-redux';
import getDecodedToken from '../../common/auth/utils/getDecodedToken';
import { Helmet } from 'react-helmet';

import BadgeWidget from './BadgeWidget';
import FavoritesWidget from './FavoritesWidget';
import ShopifyWidget from './ShopifyWidget';
import SixtyDayTrainingCourseWidget from './SixtyDayTrainingCourseWidget';
import TvWidget from './TvWidget';
import { getDashboardData, resetDashboardData } from './redux/actions';
import {
  selectLatestBadge,
  selectLatestEpisodes,
  selectLatestFavorites,
  selectSixtyDayCourse,
} from './redux/selectors';
import Loading from '../../common/components/Loading';
import ReferAFriendWidget from './ReferAFriendWidget';

class Dashboard extends Component {
  componentDidMount() {
    this.props.dispatch(getDashboardData(getDecodedToken().sub));
  }

  componentWillUnmount() {
    this.props.dispatch(resetDashboardData());
  }

  render() {
    const { latestBadge, latestEpisodes, latestFavorites, loaded, sixtyDayCourse } = this.props;

    if (!loaded) {
      return <Loading />;
    }

    return (
      <div className="dashboard container">
        <Helmet>
          <title>Tathata Golf - Dashboard</title>
        </Helmet>
        <div className="dash-left">
          <SixtyDayTrainingCourseWidget course={sixtyDayCourse} />
          <TvWidget episodes={latestEpisodes} />
          <FavoritesWidget favorites={latestFavorites} />
        </div>
        <div className="dash-right">
          <BadgeWidget badge={latestBadge} />
          <ReferAFriendWidget />
          <ShopifyWidget />
        </div>
      </div>
    );
  }
}

export default connect(state => {
  return {
    latestBadge: selectLatestBadge(state),
    latestEpisodes: selectLatestEpisodes(state),
    latestFavorites: selectLatestFavorites(state),
    loaded: state.subscription.dashboard.get('loaded'),
    sixtyDayCourse: selectSixtyDayCourse(state),
  };
})(Dashboard);



// WEBPACK FOOTER //
// ./src/subscription/dashboard/Dashboard.js